/**
 * 运营策略模拟的业务逻辑 hooks
 */
import { useState, useEffect } from 'react';
import { StrategyPhase } from '../ProfitScenario/types';
import { createInitialPhase } from './utils';
import { generateFullPlanData } from './planGenerator';
import { useTaskOperations } from './useTaskOperations';
import { usePhaseOperations } from './usePhaseOperations';

/**
 * 管理策略阶段的状态和操作
 */
export const useStrategyPhases = (initialData?: StrategyPhase[]) => {
    const [phases, setPhases] = useState<StrategyPhase[]>(initialData || [createInitialPhase()]);
    const isLoading = false;

    // 当外部传入的 initialData 变化时，更新内部状态
    useEffect(() => {
        if (initialData && initialData.length > 0) {
            setPhases(initialData);
        }
    }, [initialData]);

    const {
        addTask,
        updateTask,
        deleteTask,
        toggleTaskCompletion,
        clearCompletedTasks
    } = useTaskOperations(setPhases);

    const {
        updatePhaseInfo,
        updateWeekStrategy,
        addPhase,
        deletePhase
    } = usePhaseOperations(phases, setPhases);

    /**
     * 生成完整推广计划 (W1-W13)
     */
    const generateFullPlan = () => {
        const fullPlan = generateFullPlanData();
        setPhases(fullPlan);
    };

    return {
        phases,
        isLoading,
        updatePhaseInfo,
        updateWeekStrategy,
        addTask,
        updateTask,
        deleteTask,
        toggleTaskCompletion,
        clearCompletedTasks,
        addPhase,
        deletePhase,
        generateFullPlan
    };
};
